import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import React from 'react';
import { Link } from 'react-resource-router';

type EmptyStateMessageBodyProps = {
  message: string;
  linkType: 'internal' | 'external';
  linkTo: string;
  linkText: string;
  sendAnalyticsEvent?: () => void;
  isButton?: boolean;
};

const EmptyStateMessageBody: React.FC<EmptyStateMessageBodyProps> = ({
  message,
  linkType,
  linkTo,
  linkText,
  sendAnalyticsEvent,
  isButton = false,
}) => {
  const onClickExternalLink = () => {
    sendAnalyticsEvent && sendAnalyticsEvent();
    window.open(linkTo, '_blank');
  };
  return (
    <>
      <p css={emptyStateMessageStyles}>{message}</p>
      {linkType === 'internal' ? (
        <Link
          href={linkTo}
          onClick={sendAnalyticsEvent}
          css={[emptyStateLinkStyles, isButton && secondaryButtonStyles]}
        >
          {linkText}
        </Link>
      ) : (
        <a
          onClick={onClickExternalLink}
          css={[emptyStateLinkStyles, isButton && secondaryButtonStyles]}
        >
          {linkText}
        </a>
      )}
    </>
  );
};

export default EmptyStateMessageBody;

const emptyStateMessageStyles = css({
  color: token('color.text'),
  fontFamily: 'Inter',
  fontSize: token('space.200'),
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: token('space.300'),
  margin: 0,
});

const emptyStateLinkStyles = css({
  color: token('color.text.brand'),
  fontFamily: token('font.family.brand.body'),
  fontSize: token('space.200'),
  fontStyle: 'normal',
  fontWeight: token('font.weight.semibold'),
  lineHeight: '20px',
  cursor: 'pointer',
});

const secondaryButtonStyles = css({
  borderRadius: '4px',
  border: `1px solid ${token('color.border.brand')}`,
  display: 'flex',
  height: '40px',
  padding: `${token('space.100')} ${token('space.150')}`,
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
});
